var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationAirport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.058,
    height: 15.058,
    viewBox: "0 0 15.058 15.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-airport",
    transform: "translate(-588 -2143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.529,
    cy: 7.529,
    r: 7.529,
    transform: "translate(588 2143)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-airplane",
    "data-name": "Icon ionic-ios-airplane",
    d: "M10.65,8.461c-.076,0-.331,0-.4.007L8.8,8.506a.041.041,0,0,1-.038-.02L6.582,5.228a.359.359,0,0,0-.3-.165H5.75c-.125,0-.168.125-.123.241L6.748,8.5a.044.044,0,0,1-.04.06L3.971,8.6a.18.18,0,0,1-.148-.069L3,7.522a.355.355,0,0,0-.282-.136H2.338a.089.089,0,0,0-.085.119L2.7,9.04a.364.364,0,0,1,0,.266l-.445,1.536a.089.089,0,0,0,.085.119h.373a.362.362,0,0,0,.282-.136L3.836,9.8a.183.183,0,0,1,.148-.069l2.721.06a.044.044,0,0,1,.04.06l-1.12,3.2c-.045.116,0,.241.123.241h.53a.356.356,0,0,0,.3-.165L8.758,9.87A.044.044,0,0,1,8.8,9.85l1.451.038c.074,0,.326.007.4.007.991,0,1.617-.32,1.617-.716S11.642,8.461,10.65,8.461Z",
    transform: "translate(588.465 2141.128)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAirport);
export default __webpack_public_path__ + "static/media/location-airport.e69d0c2be143d43d50318a7922b1d9c4.svg";
export { ForwardRef as ReactComponent };